import { CincinnatiData } from "../model/CincinnatiData";
import axiosInstance from "../network/AxiosInstance";

const endpoint = process.env.REACT_APP_FACADE_ENDPOINT + "data";

export async function createData(
    category: string,
    title: string,
    path: string,
    fileName: string,
    description: string,
    dataType: string,
    body: string
): Promise<CincinnatiData> {
    return axiosInstance
        .post(`${endpoint}?action=create`, {
            'client_id': 'TranslationWeb',
            'category': category,
            'title': title,
            'path': path,
            'file_name': fileName,
            'description': description,
            'data_type': dataType,
            'body': body
        })
        .then((result) => {
            return result.data
        });
}


export async function fetchData(
    partitionKey: string,
    rangekey: string
): Promise<CincinnatiData> {
    return axiosInstance
        .get(`${endpoint}?action=fetch&partitionKey=${partitionKey}&rangeKey=${rangekey}`)
        .then((result) => {
            return result.data
        });
}